import { Input } from '@snsw/react-component-library';
import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';

export const StrictInput = (props) => {
  const [value, setValue] = useState(props.value || '');

  useEffect(() => {
    let filteredValue = value.replace(new RegExp(props.regExpPattern, props.regExpFlag), '');

    if (props.maxLength && value.length > props.maxLength) {
      filteredValue = filteredValue.substring(0, props.maxLength);
    }

    props.onChange(filteredValue);
  }, [value]);

  return (
    <>
      <Input
        value={props.value}
        onChange={(e) => setValue(e.target.value)}
        prefix={props.prefix}
        inputWidth={props.inputWidth}
      />
    </>
  );
};

StrictInput.propTypes = {
  value: PropTypes.string,
  regExpPattern: PropTypes.string,
  regExpFlag: PropTypes.string,
  maxLength: PropTypes.number,
  prefix: PropTypes.string,
  inputWidth: PropTypes.string,
  onChange: PropTypes.func,
};
